
/* injects from baggage-loader */

'use strict';
//import $ from 'jquery';
import AlertController from '../alert/alert.controller';
//import infoMonkey from '../../../../app/pages/stage-three/stage-three.controller';

import { failDialg, feedbackFinishStage, successDialg } from './quiz-macaco.const';

//import { max, min, sortBy, shuffle } from 'lodash';


export default class DialogQuizMacacoController extends AlertController {
    constructor($log, $rootScope, $timeout, $state, Dialog, Trophies, Session) {
        'ngInject';
        super($log, $rootScope);
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.Session = Session;

        this.carousel = null;

        this.distanceMonkey = 1;


        this.answers = {
            q1: {
                error: null,
                value: null
            },
            q2: {
                error: null,
                value: null
            },
            q3: {
                error: null,
                value: null
            },
            q4: {
                error: null,
                value: null
            }
        }
        this.items = [];
    }
    $onInit() {
        this.distanceMonkey += this.resolve.model.selected_monkey;
    }

    submit(form) {
        console.log("entrou submit");
        if (form.$valid) {
            console.log("entrou validação");
            if (this.resolve.model.level === 1) {
                this.answers.q1.error = this.q1Val();
                this.answers.q2.error = this.q2Val();
                this.answers.q3.error = this.q3Val();
            } else {
                this.answers.q4.error = this.q4Val();
            }

            let result = null;
            let responses = [];

            angular.forEach(this.answers, value => {
                responses.push(value.error);
            });

            result = responses.filter(error => error === true).length

            if (result === 0) {
                console.log("ACERTOU TUDO");
                this.onQuizCorrect();
            } else {
                this.Dialog.showFeedback('label-opa', failDialg, 'btn-ok', () => false);
            }
        }
    }

    q1Val() {
        return parseInt(this.answers.q1.value) !== (12 + this.distanceMonkey);
    }

    q2Val() {
        return parseInt(this.answers.q2.value) !== (12 + (this.distanceMonkey * 2));
    }

    q3Val() {
        return parseInt(this.answers.q3.value) !== (12 + (this.distanceMonkey * 3));
    }

    q4Val() {

        return parseInt(this.answers.q4.value) !== (this.resolve.model.numberFirstTrunk - this.distanceMonkey);
    }

    onQuizCorrect() {
        if (this.resolve.model.level === 2) {
            document.getElementById('monkey-player').style.zIndex = "";
            document.getElementById(this.resolve.model.trunk).style.zIndex = "";

            this.Trophies.collectThrophies('default', 'macaco');
            this.Trophies.collectThrophies('emblem', 'macaco');

            this.Dialog.showTrophy('macaco', feedbackFinishStage, () => {
                let infos = this.Session.get();
                infos.stages[2].totalCompleted++;
                this.Session.save(infos);
                this.$state.go('main');
            });
        } else {
            this.Dialog.showFeedback('label-very-good', successDialg, 'btn-ok', () => this.ok());
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-macaco/quiz-macaco.controller.js